import { useNavigate } from 'react-router';
import { textSizes } from '../../config/config';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';
import LoaderModal from '../LoaderModal';
import Text from '../Text';
import ViewReverse from '../ViewReverse';
import { useSelector } from 'react-redux';
import { fontSizes } from '../../constants/constants';

const navItems = [
  {
    label: 'general_information',
    path: '/general-information',
    name: 'generalinformation',
  },
  {
    label: 'contact_information',
    path: '/contact-information',
    name: 'contactinformation',
  },
  {
    label: 'bank_information',
    path: '/bank-information',
    name: 'bankinformation',
  },
  {
    label: 'investment_information',
    path: '/investment-information',
    name: 'investmentportfolio',
  },
  {
    label: 'custodian_information',
    path: '/custodian-details',
    name: 'custodiandetails',
  },
  {
    label: 'client_classification',
    path: '/client-classification',
    name: 'clientclassification',
  },
  {
    label: 'signature_card',
    path: '/signature-card',
    name: 'accountoperation',
  },
  {
    label: 'tax_self_certification',
    path: '/international-tax-self-certification',
    name: 'internationtaxcertificate',
  },
  {
    label: 'document_vault',
    path: '/document-vault',
    sectionKey: 'DocumentVault',
  },
  {
    label: 'submit_application',
    path: '/submit-application',
    name: 'application',
  },
];

const CorporateLayout = ({ children, step, setStep }) => {
  const navigate = useNavigate();
  const { isArabic, TextWeight } = dynamicfunction();
  const { corporate } = useSelector((state) => state.content);
  const { corporate_loading } = useSelector((state) => state.corporate);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      corporate?.corporate_form_data?.data?.attributes,
      key,
      isArabic
    );
  };

  return (
    <>
      <div className='z-[1000]'>
        <div className='lg:w-[85%] 2xl:w-[1500px] lg:mx-auto py-[8px]'>
          <Text text={getContentKey(navItems[step]?.label || '')} size={fontSizes.h19} isTruncate={false} weight={TextWeight.bold} />

          <div
            className={`flex justify-center items-center gap-[5px] my-2 flex-1 ${
              isArabic ? 'flex-row-reverse' : 'flex-row'
            }`}
          >
            {navItems.map((item, index) => (
              <div
                key={index}
                className={`h-[4px] flex-1 cursor-pointer transition-colors duration-300 ${
                  index <= step ? 'bg-[#610D24]' : 'bg-[#C5D2D8]'
                }`}
                onClick={
                  () => {
                    setStep(index);
                  }
                  // !corporate_post_loading &&
                  // navigate(item.path)
                }
              />
            ))}
          </div>

          {/* Step Counter */}
          <ViewReverse className='gap-2'>
            <Text
              text={getContentKey('step')}
              size={textSizes.h16}
              color={'text-primary'}
              isTruncate={false}
              weight={TextWeight.medium}
            />
            <Text
              text={`${String(step + 1).padStart(2, '0')}/${String(
                navItems?.length
              ).padStart(2, '0')}`}
              size={textSizes.h16}
              color={'text-primary'}
              isTruncate={false}
              weight={TextWeight.medium}
            />
          </ViewReverse>
        </div>
      </div>

      {/* Content Container */}
      <div className='mx-4 lg:w-[85%] 2xl:w-[1500px] lg:mx-auto p-8 shadow-md border border-border rounded-xl mb-6 mt-8'>
        {children}
      </div>

      <LoaderModal open={corporate_loading} />
    </>
  );
};

export default CorporateLayout;
